import * as React from "react";
import type { TableProps } from "../types";
import defaultClasses from "./index.module.css";
import cssClassAssembler from "../../sso/utils/cssClassAssembler";
import TableCell from "./TableCell";

function Table(props: TableProps) {
  function classes() {
    return {
      table: cssClassAssembler(props.classNames?.table, defaultClasses.table),
      caption: cssClassAssembler(
        props.classNames?.caption,
        defaultClasses.caption
      ),
      thead: cssClassAssembler(props.classNames?.thead, defaultClasses.thead),
      tr: cssClassAssembler(props.classNames?.tr, defaultClasses.tr),
      th: cssClassAssembler(props.classNames?.th, defaultClasses.th),
      td: cssClassAssembler(props.classNames?.td, defaultClasses.td),
      iconSpan: cssClassAssembler(
        props.classNames?.iconSpan,
        defaultClasses.iconSpan
      ),
    };
  }

  function actionClick(
    action: TableProps["actions"][number],
    item: TableProps["data"][number]
  ) {
    return () => action.handleClick(item);
  }

  function columnName(col: TableProps["cols"][number]) {
    return typeof col === "string" ? col : col.name;
  }

  return (
    <table className={classes().table}>
      {props.tableCaption ? (
        <caption className={classes().caption}>{props.tableCaption}</caption>
      ) : null}
      <thead className={classes().thead}>
        <tr className={classes().tr}>
          {props.cols?.map((col) => (
            <th scope="col" key={columnName(col)} className={classes().th}>
              {columnName(col)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.noMoreResults ? (
          <tr>
            <td
              colSpan={props.cols.length}
              className={defaultClasses.noMoreResults}
            >
              No more results found
            </td>
          </tr>
        ) : null}
        {!props.noMoreResults ? (
          <>
            {props.data?.map((item, index) => (
              <tr className={classes().tr} key={index}>
                {props.cols?.map((col, index) => (
                  <td className={classes().td} key={index}>
                    <TableCell
                      col={col}
                      rowData={item}
                      actions={props.actions}
                      classNames={classes()}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </>
        ) : null}
      </tbody>
    </table>
  );
}

export default Table;
